import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'

import { routes as auth } from 'modules/auth'
import { routes as users } from 'modules/users'
import { routes as forms } from 'modules/forms'
import { routes as config } from 'modules/config'
import { routes as questions } from 'modules/questions'
import { routes as dimensions } from 'modules/dimensions'
import { routes as formSubmissions } from 'modules/formSubmissions'

import { HomePage } from 'pages'
import { expandRoutes } from 'utils'
import { GuestLayout, UserLayout, AdminLayout } from 'layouts'

const modules = [auth, users, forms, config, questions, dimensions, formSubmissions]

export const routes = [
  {
    path: '/',
    label: 'Início',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <HomePage />
      },
      ...expandRoutes(modules, 'root'),
      {
        path: 'guest',
        element: <GuestLayout />,
        secured: 'ROLE_GUEST',
        children: [
          {
            path: '',
            element: <Navigate to='registo' />
          },
          ...expandRoutes(modules, 'guest')
        ]
      },
      {
        path: 'acesso',
        element: <UserLayout />,
        secured: 'ROLE_USER',
        children: [
          {
            path: '',
            element: <Navigate to='questionarios' />
          },
          ...expandRoutes(modules, 'user')
        ]
      },
      {
        path: 'admin',
        element: <AdminLayout />,
        secured: 'ROLE_ADMIN',
        children: [
          {
            path: '',
            element: <Navigate to='relatorios' />
          },
          ...expandRoutes(modules, 'admin')
        ]
      }
    ]
  }
]

export default routes
